import composer, { type optionPairType } from "./composer";

export default (option: optionPairType) =>
  composer(option, "textInput", {
    fieldLabel:
      'Custom Service path (optional) "make sure that the endpoint is specified"',
    fieldValue: "",
  });
